import React, { Component } from 'react'
import Auth from '../../Modules/Auth'
import axios from 'axios'
import { withCookies, Cookies } from 'react-cookie'
import { Link } from 'react-router-dom'
import Button from '@material-ui/core/Button'
import ButtonGroup from '@material-ui/core/ButtonGroup'
import moment from 'moment'
class LiveVideo extends Component {
    constructor(props) {
        super(props)

        this.state = {
            weather: '',
            temperature: {
                lowTemp: 0,
                highTemp: 0,
                curTemp: 0,
            },
            cameraIdx: 0,
        }
    }

    UNSAFE_componentWillMount() {
        this.loadWeather()
    }

    loadWeather = () => {
        const { cookies } = this.props

        axios
            .get(
                `${BACKEND_HOST}/weathers/?project_id=${cookies.get('project')}&date=${moment().format('YYYY-MM-DD')}`,
                {
                    headers: {
                        Authorization: `bearer ${Auth.getToken()}`,
                    },
                }
            )
            .then((res) => {
                console.log(res.data)
                this.setState({
                    weather: res.data.sky,
                    temperature: { lowTemp: res.data.minTemp, highTemp: res.data.maxTemp, curTemp: res.data.curTemp },
                })
            })
            .catch((err) => {
                console.log(err)
            })
    }

    selectCamera = (idx) => {
        this.setState({
            cameraIdx: idx,
        })
    }

    renderCameras = () => {
        const List = this.props.project.lives.map((list, index) => {
            return (
                <Button
                    onClick={() => {
                        this.selectCamera(index)
                    }}>
                    {list.solutionTransaction.setting.cameraName}
                </Button>
            )
        })
        return List
    }

    render() {
        // console.log(this.state);

        let VideoImg = require('../../../Res/img/live_video.jpg')

        //날씨
        let weatherText = ''
        let weatherIcon = ''

        if (this.state.weather === 'sun') {
            weatherText = '맑음'
            weatherIcon =
                '<svg xmlns="http://www.w3.org/2000/svg" width="21" height="22" viewBox="0 0 21 22">\
          <g fill="none" fillRule="evenodd" stroke="#FEBD01">\
            <path strokeWidth="1.2" d="M10.765 6.105c-2.666 0-4.839 2.196-4.839 4.896 0 2.7 2.173 4.896 4.839 4.896 2.666 0 4.839-2.195 4.839-4.896 0-2.7-2.173-4.896-4.84-4.896z"/>\
            <path strokeLinecap="round" strokeWidth=".7" d="M10.517.885c0-.124.105-.225.225-.225.124 0 .225.096.225.225v2.423a.227.227 0 0 1-.225.226.222.222 0 0 1-.225-.226V.885zM16.48 2.69a.227.227 0 0 1 .314-.05c.1.072.126.209.05.314l-1.424 1.96a.227.227 0 0 1-.315.05.222.222 0 0 1-.049-.314l1.424-1.96zm3.77 4.984a.227.227 0 0 1 .285.144.222.222 0 0 1-.145.284l-2.304.748a.227.227 0 0 1-.284-.144.222.222 0 0 1 .145-.283l2.304-.749zm.14 6.263a.227.227 0 0 1 .145.283.222.222 0 0 1-.284.144l-2.304-.749a.227.227 0 0 1-.145-.283.222.222 0 0 1 .284-.144l2.304.749zm-3.546 5.148c.073.1.048.243-.05.314a.222.222 0 0 1-.314-.05l-1.424-1.96a.227.227 0 0 1 .05-.315.222.222 0 0 1 .314.05l1.424 1.96zm-5.877 2.067a.227.227 0 0 1-.225.226.222.222 0 0 1-.225-.226v-2.423c0-.124.105-.225.225-.225.124 0 .225.095.225.225v2.423zm-5.963-1.803a.227.227 0 0 1-.314.05.222.222 0 0 1-.05-.314l1.425-1.96a.227.227 0 0 1 .314-.05c.1.072.126.209.05.314l-1.425 1.96zm-3.77-4.985a.227.227 0 0 1-.284-.144.222.222 0 0 1 .145-.283l2.304-.749a.227.227 0 0 1 .284.144.222.222 0 0 1-.145.283l-2.305.75zm-.14-6.262a.227.227 0 0 1-.144-.284.222.222 0 0 1 .283-.144l2.305.749a.227.227 0 0 1 .145.283.222.222 0 0 1-.284.144l-2.304-.748zm3.547-5.148a.227.227 0 0 1 .049-.315.222.222 0 0 1 .314.05l1.424 1.96c.074.101.049.244-.049.315a.222.222 0 0 1-.314-.05L4.64 2.953z"/>\
          </g>\
        </svg>'
        } else if (this.state.weather === 'cloud') {
            weatherText = '구름낌'
            weatherIcon =
                '<svg xmlns="http://www.w3.org/2000/svg" width="25" height="18" viewBox="0 0 25 18">\
        <g fill="none" fillRule="evenodd">\
          <path stroke="#B7BEC8" strokeWidth="1.2" d="M20.574 9.536c-.27 0-.54.03-.803.087-.842-1.98-2.808-3.3-4.935-3.3-2.654 0-4.86 1.897-5.3 4.532h-.019c-1.735 0-3.147 1.433-3.147 3.194s1.412 3.194 3.147 3.194h11.057c2.093 0 3.796-1.729 3.796-3.854 0-2.124-1.703-3.853-3.796-3.853z"/>\
          <g stroke="#FEBD01" strokeLinecap="round">\
            <path d="M11.492 5.45a4 4 0 0 0-5.727 5.533"/>\
            <path strokeWidth=".8" d="M9.707.973a.165.165 0 0 1 .19-.132c.09.016.15.097.133.19l-.304 1.723a.165.165 0 0 1-.19.132.161.161 0 0 1-.133-.189L9.707.973zm4.057 2.038a.165.165 0 0 1 .23.005.161.161 0 0 1-.002.23l-1.26 1.217a.165.165 0 0 1-.231-.005.161.161 0 0 1 .003-.231l1.26-1.216zM3.43 13.415a.165.165 0 0 1-.231-.005.161.161 0 0 1 .003-.23l1.26-1.217a.165.165 0 0 1 .23.005.161.161 0 0 1-.003.231l-1.26 1.216zM1.348 9.391a.165.165 0 0 1-.184-.14.161.161 0 0 1 .138-.185l1.734-.244a.165.165 0 0 1 .184.14.161.161 0 0 1-.138.185l-1.734.244zm.686-4.475a.165.165 0 0 1-.067-.22.161.161 0 0 1 .22-.07l1.547.823c.08.042.108.143.067.221a.161.161 0 0 1-.221.068l-1.546-.822zm3.193-3.215a.165.165 0 0 1 .076-.218.161.161 0 0 1 .219.074l.767 1.574c.04.08.003.18-.076.218a.161.161 0 0 1-.219-.074L5.227 1.7z"/>\
          </g>\
        </g>\
      </svg>'
        } else if (this.state.weather === 'gray') {
            weatherText = '흐림'
            weatherIcon =
                '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="17" viewBox="0 0 24 17">\
          <g fill="none" fillRule="evenodd" stroke="#B7BEC8" strokeWidth="1.2">\
            <path d="M19.574 8.536c-.27 0-.54.03-.803.087-.842-1.98-2.808-3.3-4.935-3.3-2.654 0-4.86 1.897-5.3 4.532h-.019c-1.735 0-3.147 1.433-3.147 3.194s1.412 3.194 3.147 3.194h11.057c2.093 0 3.796-1.729 3.796-3.854 0-2.124-1.703-3.853-3.796-3.853zM11.58 3.539C10.888 1.914 9.275.83 7.53.83c-2.18 0-3.99 1.557-4.351 3.72C1.739 4.55.58 5.726.58 7.172c0 1.445 1.159 2.621 2.583 2.621h1.24"/>\
          </g>\
        </svg>'
        } else if (this.state.weather === 'rain') {
            weatherText = '비'
            weatherIcon =
                '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="20" viewBox="0 0 24 20">\
          <g fill="none" fillRule="evenodd">\
            <path stroke="#B7BEC8" strokeWidth="1.2" d="M18.39 4.798c-.329 0-.657.036-.979.107C16.384 2.49 13.987.88 11.393.88 8.156.88 5.465 3.194 4.93 6.407h-.023c-2.116 0-3.837 1.747-3.837 3.895 0 2.147 1.721 3.895 3.837 3.895H18.39c2.553 0 4.63-2.109 4.63-4.7 0-2.59-2.077-4.699-4.63-4.699z"/>\
            <g stroke="#5B8BF7" strokeLinecap="round">\
              <path d="M5.833 17.125L7 19.145M10.5 17.125l1.167 2.02M15.167 17.125l1.166 2.02M19.833 17.125L21 19.145"/>\
            </g>\
          </g>\
        </svg>'
        } else if (this.state.weather === 'snow') {
            weatherText = '눈'
            weatherIcon =
                '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" viewBox="0 0 20 22">\
          <g fill="none" fillRule="evenodd" stroke="#5B8BF7" stroke:inecap="round" strokeWidth="1.1">\
            <path d="M9.976 1.154v19.692M12.988 2.419L10.01 5.397 6.964 2.35M12.988 19.581l-2.978-2.978-3.046 3.046"/>\
            <g>\
              <path d="M1.609 5.772l16.595 9.581M4.156 3.908L5.185 7.75 1.136 8.835M18.545 12.215l-3.842 1.03 1.085 4.049"/>\
            </g>\
            <g>\
              <path d="M18.273 5.766L1.678 15.347M18.614 8.904l-3.842-1.03 1.085-4.048M4.225 17.212l1.03-3.842-4.05-1.085"/>\
            </g>\
          </g>\
        </svg>'
        }

        let liveUrl = ''
        // console.log(this.props.project.lives)
        if (this.props.project.lives && this.props.project.lives.length > 0 && this.state.cameraIdx >= 0) {
            if (this.props.project.lives[this.state.cameraIdx].result.cmasToken) {
                liveUrl = `https://player.caas.works/${
                    this.props.project.lives[this.state.cameraIdx].result.cmasToken
                }`
            } else {
                liveUrl = `https://api.caas.works/v1/solutions/aicon/cctv/streaming/${
                this.props.project.lives[this.state.cameraIdx].result.vxgToken
            }`
            }
            

            // let cameraId = ''
            // let streamingType = this.props.project.videos[this.state.cameraIdx].streamingType
            // if (streamingType === 'webcam') {
            //     cameraId = this.props.project.videos[this.state.cameraIdx].webcamId
            // } else {
            //     cameraId = this.props.project.videos[this.state.cameraIdx].vxgWatchToken
            // }

            // liveUrl = `/video/live/${cameraId}?streamingType=${streamingType}`
        }

        return (
            <div className="video_wrap common_wrap">
                <h1>실시간 현장 상황</h1>
                {this.props.cookies.get('project_cctvView') === 'true' && liveUrl !== '' ? (
                    <div className="live_video_wrap">
                        {this.state.weather !== '' && (
                            <ul className="weather_info">
                                <div className="live_icon pc_v_impo">
                                    <div className="live_coma"></div>LIVE
                                </div>
                                <li className="weather_address pc_v_impo" style={{ width: '100%' }}>
                                    {this.props.project.address.jibunAddress}
                                </li>
                                <li className="weather_icon" dangerouslySetInnerHTML={{ __html: weatherIcon }}></li>
                                <li className="weather_text">{weatherText}</li>
                                <li className="weather_low">{this.state.temperature.lowTemp}˚C</li>
                                <li className="weather_line"></li>
                                <li className="weather_high">{this.state.temperature.highTemp}˚C</li>
                                {/* <li className="weather_cur">현재 {this.state.temperature.curTemp}˚C</li> */}
                                <div className="live_icon mobile_v_impo">
                                    <div className="live_coma"></div>LIVE
                                </div>
                            </ul>
                        )}
                        <div className="iframe_wrap">
                            <iframe title="live" src={liveUrl} allowFullScreen />
                        </div>
                        {this.props.project.lives.length > 1 && (
                            <div className="camera_select_wrap">
                                <ButtonGroup color="primary" aria-label="dark button group">
                                    {this.renderCameras()}
                                </ButtonGroup>
                            </div>
                        )}
                    </div>
                ) : (
                    <div className="live_video_wrap_no">
                        <ul className="weather_info">
                            <div className="live_icon">
                                <div className="live_coma"></div>LIVE
                            </div>
                            <li className="live_text">연결된 카메라가 없습니다.</li>
                        </ul>
                        <div className="live_video_no">
                            <img src={VideoImg} alt="loading" />
                            {/* <div className="load_bg">
                                <svg xmlns="http://www.w3.org/2000/svg" width="146" height="87" viewBox="0 0 146 87">
                                    <g fill="none" fillRule="evenodd" stroke="#FFF" strokeWidth="5" opacity=".3">
                                        <path
                                            strokeLinecap="round"
                                            d="M143.01 3.178H2.593M89.24 39.366l-32.7 32.7M19.507 24.444h105.71"
                                        />
                                        <path d="M87.448 55.897c0-7.872-6.598-14.286-14.768-14.286-8.17 0-14.768 6.414-14.768 14.286 0 7.871 6.598 14.285 14.768 14.285 8.17 0 14.768-6.414 14.768-14.285z" />
                                        <path
                                            strokeLinecap="round"
                                            d="M69.824 84.482H74.9c27.79 0 50.317-22.648 50.317-50.587V3.467H19.507v30.428c0 27.94 22.527 50.587 50.317 50.587z"
                                        />
                                    </g>
                                </svg>
                            </div> */}
                        </div>
                    </div>
                )}
            </div>
        )
    }
}

export default withCookies(LiveVideo)



// WEBPACK FOOTER //
// ./Src/Components/Dashboard/OwnerLiveVideo.js